import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { Message } from 'element-ui'
import { $t } from '@/i18n'
import { buildUriForCall } from '@/helpers/functions/buildUri'
import { capitalizeFirstLetter } from '@/helpers/capitalized'
import { fakeUrl } from '@/helpers/functions/fakeDataStats'
import moment from 'moment/moment'

export default {
  namespaced: true,
  state: {
    loadingKPI: false,
    kpi: {},
    loadingKpiSM: false,
    ranking: {
      facebook: [],
      instagram: [],
      linkedin: []
    },
    facebook: {
      labels: [],
      data: []
    },
    instagram: {
      labels: [],
      data: []
    },
    linkedin: {
      labels: [],
      data: []
    }
  },
  getters: {
    getKpi: (state) => state.kpi,
    getLoadingKPI: (state) => state.loadingKPI,
    getLoadingKpiSM: (state) => state.loadingKpiSM,
    getRankingFacebook: (state) => state.ranking.facebook,
    getRankingInstagram: (state) => state.ranking.instagram,
    getRankingLinkedin: (state) => state.ranking.linkedin,
    getFacebookData: (state) => state.facebook.data,
    getFacebookLabels: (state) => state.facebook.labels,
    getInstagramData: (state) => state.instagram.data,
    getInstagramLabels: (state) => state.instagram.labels,
    getLinkedinData: (state) => state.linkedin.data,
    getLinkedinLabels: (state) => state.linkedin.labels
  },
  mutations: {
    setKPI (state, data) {
      state.kpi = data.kpi
    },
    setLoadingKPI (state, bool) {
      state.loadingKPI = bool
    },
    setLoadingKpiSM (state, bool) {
      state.loadingKpiSM = bool
    },
    setRankingFacebook (state, ranking) {
      state.ranking.facebook = ranking
    },
    setRankingInstagram (state, ranking) {
      state.ranking.instagram = ranking
    },
    setRankingLinkedin (state, ranking) {
      state.ranking.linkedin = ranking
    },
    setFacebookLabels (state, labels) {
      state.facebook.labels = labels
    },
    setFacebookData (state, data) {
      state.facebook.data = data
    },
    setInstagramLabels (state, labels) {
      state.instagram.labels = labels
    },
    setInstagramData (state, data) {
      state.instagram.data = data
    },
    setLinkedinLabels (state, labels) {
      state.linkedin.labels = labels
    },
    setLinkedinData (state, data) {
      state.linkedin.data = data
    }
  },
  actions: {
    loadKPI ({ commit }) {
      commit('setLoadingKPI', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/kpi/dashboard')
        .then(response => {
          commit('setKPI', response.data)
        })
        .catch(() => {
          Message.error($t('KPI.messageErrorLoading'))
        })
        .finally(() => {
          commit('setLoadingKPI', false)
        })
    },
    loadKpiSM ({ commit, state }, { datatype, diffuseur }) {
      commit('setLoadingKpiSM', true)

      const path = fakeUrl('/kpi/sm/dashboard', '/fake/kpi/sm/dashboard')

      const params = {
        diffuseurCode: diffuseur,
        keyIndicator: 'POST_LIKES',
        dataType: datatype,
        startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      }

      const networkUpperCase = diffuseur.split('_')[0]
      const network = capitalizeFirstLetter(networkUpperCase.toLowerCase())
      const uri = buildUriForCall(path, params)

      HTTP_HYPER_ESPACE_BACKEND.get(uri)
        .then(response => {
          const data = response.data

          if ((datatype === 'ranking' || datatype === 'all')) {
            const ranking = data.ranking
            if (ranking.length > 0) {
              const networkData = extractRankingDataByNetwork(ranking, diffuseur)
              commit(`setRanking${network}`, networkData)
            }
          }
          if ((datatype === 'growing' || datatype === 'all')) {
            const growingCommunity = data.growingCommunity
            if (growingCommunity.length > 0) {
              const networkData = extractGrowingCommunityDataByNetwork(growingCommunity, diffuseur)
              commit(`set${network}Data`, networkData.valeurs)
              commit(`set${network}Labels`, networkData.labels)
            }
          }
        }).catch((e) => {
          console.log(e)
        }).finally(() => {
          commit('setLoadingKpiSM', false)
        })
    }
  }
}

export const extractGrowingCommunityDataByNetwork = (data, diffuseurCode) => {
  const filtered = data.filter(item => item.media === diffuseurCode)
  return {
    valeurs: filtered.map(item => parseInt(item.valeur)),
    labels: filtered.map(item => new Date(item.date.date).toLocaleDateString('fr-FR'))
  }
}

export const extractRankingDataByNetwork = (data, network) => {
  return data.filter(item => item.media === network)
}
